import Turbolinks from "turbolinks";
import BaseController from "./base_controller";

export default class extends BaseController {
  static targets = [];

  connect() {
    this.siteNum = this.data.get("siteNum");
  }
}
